import { format, formatInTimeZone, utcToZonedTime } from "date-fns-tz";
import { parseISO } from "date-fns";

export const DEFAULT_FORMAT_DATE_TIME = "yyyy-MM-dd HH:mm:ss";
export const DEFAULT_TIME_ZONE = "Europe/Madrid";
export const asUTC = (date: Date, dateFormat?: string): string => {
  return format(utcToZonedTime(date, "UTC"), dateFormat || "dd/MM/yyyy", { timeZone: "UTC" });
};
export const asUTCTime = (date: Date, dateFormat?: string): string => {
  return format(utcToZonedTime(date, "UTC"), dateFormat || "dd/MM/yyyy hh:mm:ss", {
    timeZone: "UTC",
  });
};

export const convertUTCToEstablishmentTime = (
  date: string,
  timeZone: string = DEFAULT_TIME_ZONE,
  dateFormat: string = DEFAULT_FORMAT_DATE_TIME
): string => {
  try {
    return formatInTimeZone(date, timeZone, dateFormat);
  } catch (e) {
    console.log("Error converting date", e);
    return formatInTimeZone(date, DEFAULT_TIME_ZONE, dateFormat);
  }
};

export function currentDate() {
  return new Date();
}

export function dateToString(date: Date, formatStr = "yyyy-MM-dd") {
  return format(date, formatStr);
}

export function stringToDate(date?: string | null) {
  if (!date) return new Date();
  return parseISO(date);
}

// @ts-ignore
export function dateStringToProtoTimestamp(date: string): proto.google.protobuf.Timestamp {
  // @ts-ignore
  const timestamp = new proto.google.protobuf.Timestamp();
  timestamp.fromDate(new Date(date));
  return timestamp;
}
